import { render, staticRenderFns } from "./DependentsByLGAChart.vue?vue&type=template&id=2fcaba94&"
import script from "./DependentsByLGAChart.vue?vue&type=script&lang=js&"
export * from "./DependentsByLGAChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports